"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var makeStyles_1 = __importDefault(require("@mui/styles/makeStyles"));
var classnames_1 = __importDefault(require("classnames"));
var flavor_config_1 = require("../flavor-config");
var useStyles = (0, makeStyles_1.default)({
    image: {
        paddingLeft: 24,
        paddingRight: 8,
        paddingBottom: 2,
        height: (_b = (_a = flavor_config_1.FLAVOR_STYLE_CONFIG.logo) === null || _a === void 0 ? void 0 : _a.size) !== null && _b !== void 0 ? _b : 22,
    },
});
var Logo = function (_a) {
    var src = _a.src, className = _a.className;
    var classes = useStyles();
    return (React.createElement("img", { src: src, className: (0, classnames_1.default)(classes.image, className) }));
};
exports.default = Logo;
